// discountPresets.js — ready-made discounts for the calculators' "Discount
// preset" dropdown. Add more here; each sets the discount fields and can
// pre-fill the Personal note in the send dialogs (personalNote).
//
// No preset key is saved with the quote: a preset is "on" whenever the
// discount fields match it exactly, so editing the % or the reason by hand
// simply turns it into a manual discount.
export const DISCOUNT_PRESETS = {
  showcase: {
    label: "Showcase vehicle rate (20%)",
    discountType: "percent",
    discountValue: 20,
    discountReason: "Showcase vehicle rate: reduced dry ice cleaning",
    // Reasons this preset had before (quotes saved with them still read as it).
    oldReasons: ["Showcase Project rate"],
    // Pre-fills the send dialogs' Personal note (still editable).
    personalNote: ({ make, pct, saving }) =>
      `As this is the first ${make || "one of these"} we've had through the workshop, we'd love to document the work for our portfolio. If you're happy for us to photograph and film the process, completely discreetly with no number plates or personal details shown, we can offer you our Showcase vehicle rate of ${pct}% off, a saving of ${saving}, which is already reflected in the quote below.`,
  },
};

// The preset key the commercial settings currently match, or "".
export function activeDiscountPreset(commercial) {
  if (!commercial) return "";
  return Object.keys(DISCOUNT_PRESETS).find(k => {
    const p = DISCOUNT_PRESETS[k];
    return commercial.discountType === p.discountType
      && Number(commercial.discountValue) === p.discountValue
      && [p.discountReason, ...(p.oldReasons || [])].includes((commercial.discountReason || "").trim());
  }) || "";
}

// Commercial settings with a preset applied ("" clears the discount).
export function applyDiscountPreset(commercial, key) {
  const p = DISCOUNT_PRESETS[key];
  if (!p) return { ...commercial, discountType: "none", discountValue: 0, discountTargetPrice: null, discountReason: "" };
  return { ...commercial, discountType: p.discountType, discountValue: p.discountValue, discountTargetPrice: null, discountReason: p.discountReason };
}

// The Personal note a preset pre-fills, or "" (no preset / none set).
// discount: resolveDiscount(...) for the quote, for the £ saving.
export function presetPersonalNote(stateJson, discount) {
  const p = DISCOUNT_PRESETS[activeDiscountPreset(stateJson?.commercial)];
  if (!p?.personalNote) return "";
  const saving = "£" + Number(discount?.amount || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return p.personalNote({ make: (stateJson?.vehicle?.make || "").trim(), pct: p.discountValue, saving });
}
